// extracted by mini-css-extract-plugin
module.exports = {"stakeSelector":"_058c0a8","caption":"_2332218","gameIcon":"_6642ce4"};